import { createContext, useContext } from 'react';

const ModalControllerContext = createContext(null);

// PROVIDER

export const ModalControllerProvider = ({ controller, children }) => (
    <ModalControllerContext.Provider value={controller}>{children}</ModalControllerContext.Provider>
);

// INTERNAL CONTEXT ACCESS

const useModalControllerContext = () => {
    const ctx = useContext(ModalControllerContext);

    if (!ctx) throw new Error('Modal hooks must be used inside ModalControllerProvider');

    return ctx;
};

// READ-ONLY SELECTORS

export const useModalView = () => useModalControllerContext().view;
export const useModalPayload = () => useModalControllerContext().viewPayload;

// ACTION

export const useModalAction = () => {
    const { action, setAction } = useModalControllerContext();

    return { action, setAction };
};

// ENTRY TYPE

export const useModalEntryType = () => {
    const { entryType, setEntryType } = useModalControllerContext();

    return { entryType, setEntryType };
};

// PICKER

export const useModalPicker = () => {
    const { pickerMode, onPickItems } = useModalControllerContext();

    return { pickerMode, onPickItems };
};

// NAVIGATION

export const useModalNavigation = () => {
    const { setView, replaceView, goBack, close, closeWithDelay, canGoBack } = useModalControllerContext();

    return {
        setView,
        replaceView,
        goBack,
        close,
        closeWithDelay,
        canGoBack
    };
};

// SEARCH

export const useModalSearch = () => useModalControllerContext().search;
